import { z } from "zod";
import { PagedVideoItemDto } from "./video.ts";
import { DfyOrderListItemDto } from "./dfy.ts";

export const HomeRecentItemDto = z.discriminatedUnion("type", [
  z.object({ type: z.literal("VIDEO"), video: PagedVideoItemDto }),
  z.object({ type: z.literal("DFY_ORDER"), order: DfyOrderListItemDto }),
]);

export const HomeResponseDto = z.object({
  hasCreatedContent: z.boolean(),
  recent: z.array(HomeRecentItemDto),
});

export type HomeRecentItemDto = z.infer<typeof HomeRecentItemDto>;
export type HomeResponseDto = z.infer<typeof HomeResponseDto>;
